var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"YoutubeVideo",class:{ loading: _vm.loading, loaded: _vm.loaded }},[_c('div',{staticClass:"aspectHelper",style:({ paddingTop: (((1 / _vm.aspectRatio) * 100) + "%") })}),_c('div',{ref:"host",staticClass:"video"})])}
var staticRenderFns = []

export { render, staticRenderFns }